import { apiClient } from './api';
import type {
  TenantCoachLead,
  TenantCoachLeadInboxResponse,
  TenantCoachLeadUpdatePayload,
} from '../types';

export async function getCoachLeadInbox(): Promise<TenantCoachLeadInboxResponse> {
  const response = await apiClient.get<TenantCoachLeadInboxResponse>('/api/v1/web/coach-leads');
  return response.data;
}

export async function updateCoachProviderLead(
  requestId: number,
  payload: TenantCoachLeadUpdatePayload
): Promise<TenantCoachLead> {
  const response = await apiClient.patch<TenantCoachLead>(
    `/api/v1/web/coach-leads/provider-requests/${requestId}`,
    payload
  );
  return response.data;
}
